/* eslint-disable no-prototype-builtins */
// import Vue from "vue";
import { createRouter, createWebHistory } from "vue-router";
import Auditorium from "./components/pages/Auditorium.vue";
import Theory from "./components/pages/Theory.vue";
import Placemaking from "./components/pages/Placemaking.vue";
import Traversing from "./components/pages/Traversing.vue";
import Subscribe from "./components/pages/Subscribe.vue";
import store from "./store.js";

let routes = [
  { path: "/", component: Auditorium },
  { path: "/theory", component: Theory },
  { path: "/placemaking", component: Placemaking },
  { path: "/traversing", component: Traversing },
  { path: "/subscribe", component: Subscribe }
];

const router = createRouter({
  history: createWebHistory(),
  routes, // short for `routes: routes`
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        let top = 0;
        if (store.state.savedPositions.hasOwnProperty(to.path)) {
          top = store.state.savedPositions[to.path];
        }

        resolve({ top: top, behavior: "instant" });
      }, 450);
    });

    // if (savedPosition) {
    //   return savedPosition;
    // }
    // } else {
    //   return { top: 0, behavior: "smooth" };
    // }
  }
});

export default router;
